<template>
  <div class="mb-2 root background_screen">
    
    <v-form
      ref="filter"
      class="mx-2"
    >
      <v-toolbar
        flat
        class="my-3 background_screen"
      >
        <v-toolbar-title> Acionamento de Conjuntos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="d-flex align-center justify-space-around mx-2">
          
          <v-autocomplete
            v-model="controller.selectedPlace"
            :items="controller.placePagination.items"
            item-text="name"
            item-value="id"
            dense
            filled
            class="pt-6 pl-2"
            label="Selecione o Levante"
            style="max-width: 14rem"
            return-object
            @change="controller.changePlace($event)"
            single-line
          ></v-autocomplete>
          <div class="ml-2">
            <v-btn
              v-if="selectedItems.length !== 0"
              height="38"
              color="primary"
              class="mt-0"
              @click="toggleStatusForSelectedItems"
            >
              <v-icon left> mdi-swap-horizontal </v-icon>
              Alterar Estado
            </v-btn>
          </div>
        </v-toolbar-items>
      </v-toolbar>
    </v-form>
    
    <div v-if="!controller.selectedPlace.name || controller.pumpMotoPagination.items.length === 0" class="warning-message">
      <v-alert class="text-h6">
        {{ !controller.selectedPlace.name ? 'Por favor, selecione um levante para visualizar os conjuntos.' : 'Não foram encontrados conjuntos para o levante selecionado.' }}
      </v-alert>
    </div>

    <div
      v-if="controller.selectedPlace.name"
      :class="{
        'd-flex mt-3 mb-n4 pa-8 justify-space-between': true,
        'flex-column-reverse mt-0': $vuetify.breakpoint.smAndDown,
        'background_screen': $vuetify.theme.isDark,
        'white-bg': !$vuetify.theme.isDark
      }"
    >
      <div :class="{'d-flex flex-column': true, 'mt-8': $vuetify.breakpoint.smAndDown}">
        <div class="d-flex justify-start">
          <div>
            <span class="text-subtitle-1">Acionamentos</span>
          </div>
          <div>
            <v-icon class="mr-2">mdi-chevron-right</v-icon>
            <span class="text-subtitle-1">{{ controller.selectedPlace.name }}</span>
          </div>
        </div>

        <template v-if="controller.lastPlaceEvent">
          <div class="d-flex mt-2 justify-start">
            <p class="text-subtitle-1 mb-0">Último acionamento do levante: {{ dayjs(controller.lastPlaceEvent.created_date).format("DD/MM/YYYY HH:mm") }}</p>
          
            <v-tooltip right max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on" class="ml-2">mdi-help-circle-outline</v-icon>
              </template>
              <span>
                Detalhes: {{ controller.lastPlaceEvent.description }}
              </span>
            </v-tooltip>
          </div>
        </template>
        <template v-else>
          <p>Sem eventos de acionamento para o levante {{ controller.selectedPlace.name }}</p>
        </template>
      </div>

      <div
        style="max-width: 20rem"
        :class="{'borders': $vuetify.breakpoint.smAndDown, 'd-flex flex-column': true}"
      >
        <v-btn
          height="38"
          color="primary"
          class="mt-0 mb-1"
          @click="healthCheck"
          :disabled="loadingHealthCheckResponse"
        >
          <template v-if="loadingHealthCheckResponse">
            <v-icon class="rotate" color="grey">mdi-loading</v-icon> Carregando...
          </template>
          <template v-else>
            Testar conexão com o levante
          </template>
        </v-btn>

        <template v-if="controller.lastHealthCheck">
          <div class="d-flex mt-2">
            <p class="text-subtitle-1 mb-0">Último teste de conexão: {{ dayjs(controller.lastHealthCheck.created_date).format("DD/MM/YYYY HH:mm") }}</p>
          
            <v-tooltip right max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on" class="ml-0">mdi-help-circle-outline</v-icon>
              </template>
              <span>
                {{ controller.lastHealthCheck.description }}
              </span>
            </v-tooltip>
          </div>
        </template>
        <template v-else>
          Sem testes de conexão para este levante
        </template>
      </div>
    </div>
    
    <v-row  class="mt-4 pa-4" :class="$vuetify.theme.isDark ? 'background_screen'  : 'white-bg'">
      <v-col v-for="(item, index) in controller.pumpMotoPagination.items" :key="index" cols="12" sm="6" md="4" lg="3">
        <div class="card d-flex flex-column gap" :class="{
          'border-grey': item.loading,
          'border-yellow': !item.loading && !conection(item),
          'border-green': !item.loading && conection(item) && on(item),
          'border-red': !item.loading && conection(item) && !on(item),
          'white-bg': !$vuetify.theme.isDark,
          'gray-bg': $vuetify.theme.isDark
        } ">
    
        <div class="d-flex">
          <v-col cols="1">
            <v-checkbox v-model="item.checkbox" @change="toggleItemSelected(item)" class="mt-2 mr-0"></v-checkbox>
          </v-col>
          <v-col cols="1">
            <v-tooltip right max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on" class="mt-4 ml-0">mdi-help-circle-outline</v-icon>
              </template>
              <span>
                Para realizar um acionamento em conjunto, marque a caixa de seleção 
                <br/>
                em cada conjunto desejado para alterar seu estado de ativação para ligado ou desligado.
              </span>
            </v-tooltip>
          </v-col>
          
          <v-col>
            <div class="font-weight-medium text-subtitle-1">Conjunto Moto-Bomba {{ item.id }}</div>
            <div class="card__title text-caption grey--text text--darken-1">
              {{ computedEngineName(item.EngineID) }} / {{ computedPumpName(item.pumpID) }}
            </div>
          </v-col>
        </div>

        <template v-if="!loadingStatusUpdate">
          <div class="pa-4">
            <!-- Último evento -->
            <div class="mb-4">
              <template v-if="pumpMotoEvents[item.id]">
                <div class="d-flex align-center justify-center">
                  <div>
                    <div class="font-weight-medium text-subtitle-2">
                      Última mudança no conjunto:
                    </div>
                    <div class="grey--text text--darken-1">
                      {{ dayjs(pumpMotoEvents[item.id].created_date).format("DD/MM/YYYY HH:mm") }}
                    </div>
                  </div>

                  <v-tooltip right max-width="300px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="ml-2"
                        color="grey darken-1"
                      >
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ pumpMotoEvents[item.id].description }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-else>
                <div class="grey--text text--darken-1">
                  Este conjunto ainda não possui eventos de acionamento.
                </div>
              </template>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- Estado e Acionamento -->
            <v-row dense>
              <v-col cols="6">
                <v-sheet class="pa-4 grey lighten-5 rounded-lg text-center">
                  <div class="font-weight-medium text-subtitle-2">Estado Atual</div>
                  <div
                    class="font-weight-bold text-h6"
                    :class="on(item) ? 'green--text text--darken-2' : 'red--text text--darken-2'"
                  >
                    {{ on(item) ? 'Ligado' : 'Desligado' }}
                  </div>
                </v-sheet>
              </v-col>

              <v-col cols="6">
                <v-sheet class="pa-4 grey lighten-5 rounded-lg text-center">
                  <div class="font-weight-medium text-subtitle-2">Acionamento</div>
                  <div class="font-weight-bold text-h6">
                    {{ item.remoteControl ? 'Remoto' : 'Local' }}
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- Botão principal -->
            <div class="text-center">
              <v-btn
                color="primary"
                large
                depressed
                :disabled="item.loading || item.isButtonDisabled"
                @click="toggleStatus(item)"
              >
                <template v-if="item.loading">
                  <v-icon class="mr-2 rotate" color="grey">mdi-loading</v-icon>
                  {{ on(item) ? 'Desligando...' : 'Ligando...' }}
                </template>
                <template v-else>
                  {{ item.Status === 0 ? 'Ligar' : 'Desligar' }}
                </template>
              </v-btn>
            </div>
          </div>
        </template>
        <template v-else>
          <v-card outlined class="pa-4 text-center">
            <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
            <div class="mt-3">Atualizando os dados do conjunto. Por favor aguarde...</div>
          </v-card>
        </template>

        <div class="card__notification align-center justify-center flex-column gap">
          <div class="notify" v-if="!conection(item)">
            <v-icon color="yellow">mdi-alert</v-icon>
            Falha na comunicação
          </div>
          <div class="notify" v-else>
            <v-icon color="green">mdi-check</v-icon>
            Comunicação OK
          </div>
        </div>
      </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const defaultParams = {
  sort: 2,
  descending: false,
  page: 1,
  itemsPerPage: 40,
  search: '',
  status: 0
}
const AllParams = {
  sort: 2,
  descending: false,
  page: 1,
  itemsPerPage: 1000,
  search: '',
  status: 0
}
import { axosInstance } from "@/di/axios_instance_di";
import DriveCard from '../components/DriveCard.vue'
import { remoteControlController } from "@/di/di";
import _ from "lodash";
import { snackbar } from '@/core/controller/snackbar_controller';

import { STATUS } from '@/module/pump_moto/domain/model/pump_moto';

export default {
  components: {
    DriveCard
  },
  data: (context) => ({
    controller: remoteControlController(context),
    activationModal: false,
    pumpMoto: [],
    engines: [],
    pumps: [],
    delayedStatus: '',
    selectAll: false,
    lastEvent: "Carregando...",
    pumpMotoEvents: {},

    // TODO: validate this states
    loadingHealthCheckResponse: false,
    loadingStatusUpdate: false,
    pendingRefetchTimeouts: [],
    shouldRefetchEvents: true,
    initialStatuses: [],
    attemps: 1
  }),
  methods: {
    async fetchPumpMoto(params) {
      await this.fetchPumps(AllParams);
      await this.fetchEngines(AllParams);
    },
    
    async fetchEngines(params) {
      try {
        const { data } = await axosInstance.get('/engine', {
          params
        })
        
        this.engines = data.items
        
      } catch (error) {
        console.error(error)
      }
    },
    async healthCheck() {
      this.loadingHealthCheckResponse = true

      try {
        await this.controller.healthCheck()
      } catch (e) {
        console.error("remote control :: health check  :: ", e)
      }

      this.loadingHealthCheckResponse = false
    },
    async fetchPumps(params) {
      try {
        const { data } = await axosInstance.get('/pump', {
          params
        })
        this.pumps = data.items
      } catch (error) {
        console.error(error)
      }
    },
    conection(item) {
      return item.withPump;
    },
    on(item) {
      return item.Status === STATUS.ACTIVE;
    },
    async fetchLastEventForPumpMoto(pumpMoto) {
      try {
        const result = await this.controller.lastEventFor(pumpMoto);
        this.$set(this.pumpMotoEvents, pumpMoto.id, result);
      } catch (error) {
        console.error('Error fetching event:', error);
        this.$set(this.pumpMotoEvents, pumpMoto.id, { description: "Erro ao carregar evento" });
      }
    },
    // TODO: refac this code to make more readable/easy
    // deal with event updates
    async refetchPumpMotoWithRetry(ids) {
      this.loadingStatusUpdate = true

      if (this.attemps > 2) {
        this.controller.pumpMotoPagination.items.forEach(i => {
          i.isButtonDisabled = false
          i.loading = false
        });
        
        this.pendingRefetchTimeouts.forEach(clearTimeout)
        this.pendingRefetchTimeouts = []
        this.attemps = 1
        this.loadingStatusUpdate = false
        return
      }

      if (this.attemps > 1) {
        snackbar.show({ 
          message: "A atualizacao esta demorando um pouco mais que o esperado, tentando novamente", 
          color: 'blue', 
          timeout: 5000 
        });
      }

      const timeoutId = setTimeout(async () => {
        await this.controller.paginate();

        this.controller.pumpMotoPagination.items.forEach(i => {
          if (!ids.includes(i.id)) return

          this.$set(i, 'loading', true);
          this.$set(i, 'isButtonDisabled', true);
        });

        const currentStatues = this.controller.pumpMotoPagination.items.map(item => item.Status)
        const shouldRefetch = _.isEqual(currentStatues, this.initialStatuses)

        if (shouldRefetch) this.refetchPumpMotoWithRetry(ids);
        else {
          this.loadingStatusUpdate = false

          this.controller.pumpMotoPagination.items.forEach(i => {
            this.$set(i, 'loading', false);
            this.$set(i, 'isButtonDisabled', false);
          });
        }
      }, 10000 / this.attemps);

      this.pendingRefetchTimeouts.push(timeoutId)
      this.attemps += 1
    },
    toggleSelectAll() {
      this.controller.pumpMotoPagination.items.forEach(item => {
        item.checkbox = this.selectAll;
      });
    },
    // TODO: avoid fetch events on toggle the status
    async toggleStatus(item) {
      this.initialStatuses = this.controller.pumpMotoPagination.items.map(item => item.Status)

      this.$set(item, 'loading', true);

      const success = await this.controller.handleChange(item);

      if (!success) {
        this.$set(item, 'withPump', false);
        this.$set(item, 'loading', false);

        return;
      };

      await this.refetchPumpMotoWithRetry([item.id]);
    },
    computedPumpName(id) {
      const pump = this.pumps.find(pump => pump.id === id);
      return pump ? `Bomba ${pump.name} (${id})` : '';
    },

    computedEngineName(id) {
      const engine = this.engines.find(engine => engine.id === id);
      return engine ? `Motor ${engine.name} (${id})` : '';
    },

    toggleSelectAll() {
      this.controller.pumpMotoPagination.items.forEach(item => {
        item.checkbox = this.selectAll;
      });
    },
    toggleItemSelected(item) {
      this.shouldRefetchEvents = false

      this.controller.pumpMotoPagination.items.forEach((i) => {
        this.$set(i, 'isButtonDisabled', true);
      });

      if(this.selectedItems.length === 0) {
        this.controller.pumpMotoPagination.items.forEach((i) => {
          this.$set(i, 'isButtonDisabled', false);
        });

        this.shouldRefetchEvents = true
      }
    },
    async toggleStatusForSelectedItems() {
      this.selectedItems.forEach(item => this.$set(item, 'loading', true))
      const items = this.selectedItems

      const success = await this.controller.handleMultiChange();

      if (!success) {
        this.selectedItems.forEach(item => {

          this.$set(item, 'withPump', false);
          this.$set(item, 'loading', false);
          return;
        });
      }

      this.shouldRefetchEvents = true

      await this.refetchPumpMotoWithRetry(items.map(i => i.id))
      await Promise.all(items.map(item => this.fetchLastEventForPumpMoto(item)));
    },
  },
  
  watch: {
    "controller.options"() {
      this.controller.watchOptions();
    },
    "controller.search": _.debounce(function () {
      this.controller.watchSearch();
    }, 500),
    "controller.optionsPlace"() {
      this.controller.watchOptionsPlace();
    },
    "controller.searchPlace": _.debounce(function () {
      this.controller.watchSearchPlace();
    }, 500),
    "controller.searchTracking": _.debounce(function () {
      this.controller.watchSearchTracking();
    }, 500),
    "controller.optionsTracking"() {
      this.controller.watchOptionsTracking();
    },
    "controller.searchCompany": _.debounce(function () {
      this.controller.watchSearchCompany();
    }, 500),
    "controller.optionsCompany"() {
      this.controller.watchOptionsCompany();
    },
    'selectedEngine.id': function (newVal) {
      this.controller.pumpMoto.EngineID = newVal;
    },
    'controller.selectedPlace':  function (v) {
      this.controller.fetchLastHealthCheck()
      this.controller.fetchLastPlaceEvent()
    },
    // e aqui por fim
    'controller.pumpMotoPagination.items': async function(newItems) {
      if (newItems && newItems.length > 0 && this.shouldRefetchEvents) {
        await Promise.all(newItems.map(item => this.fetchLastEventForPumpMoto(item)));
      }
    },
  },
  computed: {
    selectedItems() {
      return this.controller.pumpMotoPagination.items.filter(item => item.checkbox);
    },
  },
  async mounted() {
    await this.fetchPumpMoto(defaultParams);
    this.controller.paginate();   
  },
}
</script>

<style>
.card {
  text-align: center;
  max-width: 350px;
  height: 100%;
  padding: 1rem;
  border-radius: 16px;
}
.card__subtitle {
  display: flex;
  justify-content: space-between;
}
.card__actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.card__notification {
  margin-top: 10px;
  border-top: 2px solid rgb(69, 69, 69);
  display: flex;
  justify-content: center;
}
.card__notification .notify {
  display: flex;
  align-items: center;
  padding-top: 14px;
  gap: 8px;
}
.borders {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.gap {
  gap: 1rem;
}
.border-green {
  border: 2px solid green;
}
.border-red {
  border: 2px solid red;
}
.border-yellow {
  border: 2px solid rgb(250, 206, 45);
}
.white-bg {
  background-color: white !important;
}
.gray-bg {
  background-color: gray !important;
}
.rotate {
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.v-tooltip__content {
    background-color: #1b1b1b;
    color: #fff;
    padding: 8px;
    font-size: 14px;
    border-radius: 8px;
}
.warning-message {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  text-align: center;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>
